import { createFileRoute } from "@tanstack/react-router";

import { OtherAccounts } from "~/components/feature/results/components";

export const Route = createFileRoute("/_app/dashboard/results/other-accounts/")(
  {
    component: RouteComponent,
  },
);

function RouteComponent() {
  return <OtherAccounts />;
}
